import React, { createContext, useContext, useState, useCallback } from 'react';

const VISITED_KEY = 'ssi_visited';
const NOTES_KEY   = 'ssi_notes';

function loadVisited() {
  try { return new Set(JSON.parse(localStorage.getItem(VISITED_KEY)) || []); }
  catch { return new Set(); }
}

function loadNotes() {
  try { return JSON.parse(localStorage.getItem(NOTES_KEY)) || {}; }
  catch { return {}; }
}

const VisitedContext = createContext(null);

export function VisitedProvider({ children }) {
  const [visited, setVisited] = useState(loadVisited);
  const [notes, setNotesState] = useState(loadNotes);

  const toggle = useCallback(id => {
    setVisited(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      localStorage.setItem(VISITED_KEY, JSON.stringify([...next]));
      return next;
    });
  }, []);

  const setNote = useCallback((id, text) => {
    setNotesState(prev => {
      const next = { ...prev };
      if (text.trim()) next[id] = text;
      else delete next[id];
      localStorage.setItem(NOTES_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const reset = useCallback(() => {
    localStorage.removeItem(VISITED_KEY);
    localStorage.removeItem(NOTES_KEY);
    setVisited(new Set());
    setNotesState({});
  }, []);

  return (
    <VisitedContext.Provider value={{ visited, toggle, notes, setNote, reset }}>
      {children}
    </VisitedContext.Provider>
  );
}

export function useVisited() {
  return useContext(VisitedContext);
}
